export const APIS = {
  HGTAG: 'HGTAG',
  IDENTITY: 'IDENTITY',
  AZURE_STORAGE: 'AZURE_STORAGE',
  AZURE_COMMON_STORAGE: 'AZURE_COMMON_STORAGE'
};
